import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import axiosInstance from 'utils/axios';

// eslint-disable-next-line import/prefer-default-export
export async function fetchTransferModes(destinationCode) {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = `${ARYABHATTA_API_DOMAIN_V1}auto-quote/transfers/transfer-modes?destinationCode=${destinationCode}`;
        const {
            data: {
                response: { results: transferModes }
            }
        } = await axiosInstance.get(url);
        return transferModes;
    } catch (error) {
        throw error;
    }
}

export async function removeTransfer(bookingCode, itineraryId, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/customize-itinerary/${itineraryId}`;
        const { data } = await axiosInstance.post(url, payload, {
            headers: {
                source: 'mweb'
            }
        });
        return data;
    } catch (error) {
        throw error;
    }
}
